module.exports = __webpack_public_path__ + "static/img/icon-logo-white.d4abab4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-logo-white.svg
// module id = V/7x
// module chunks = 21